import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reporte/reportecuentas';
import ReporteCuentas from './ReporteCuentas';

const mstp = state => {
    return {
        ...state.reportecuentas,
        permisos: state.login.me.permisos
    }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ReporteCuentas)
